/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationInputDimGrades } from './oralExamSubEvaluationInputDimGrades';

/**
 * Per-question evaluation from an oral exam, used by the grade-preview endpoint.
 */
export interface OralExamSubEvaluationInput {
  id: string;
  dimGrades: OralExamSubEvaluationInputDimGrades;
}
